import { useMemo } from 'react';

import { BootstrapTable } from '@components/Table/Table';

export const OutboundTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Destination',
        accessor: 'destination',
        className: 'col-md-3',
      },
      {
        Header: 'Call setup',
        accessor: 'call_setup_price',
        className: 'col-md-1',
      },
      {
        Header: 'Price per minute',
        accessor: 'minute_price',
        className: 'col-md-1',
      },
      {
        Header: 'Currency traffic',
        accessor: 'traffic_currency',
        className: 'col-md-1',
      },
      {
        Header: 'Billing method',
        accessor: 'billing_method',
        className: 'col-md-1',
      },
    ],
    []
  );

  if (!data) {
    return null;
  }

  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, bordered: true })}
    />
  );
};
